"use client";

import { Card } from "@/shared/components/common/Card";
import Separator from "@/shared/components/common/separator";
import SidebarcardHeader from "./components/SidebarcardHeader";
import SidebarcardFooter from "./components/SidebarcardFooter";
import Discount from "./components/Discount";
import SidebarcardBody from "./components/SidebarcardBody";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";

type SidebarData = {
  img: string;
  title: string;
  stayNight: number;
  checkin: string;
  checkout: string;
  rooms: MinPriceRoom[];
  link?: string;
  description?: string;
  stars?: string;
  roomAvailable?: boolean;
};

interface SidebarCardProps {
  sidebarData: SidebarData;
  loading?: boolean;
  page?: "Detail" | "Passengers" | "Confirm";
  onSubmit?: () => void;
}

export default function SidebarCard({
  sidebarData,
  loading,
  page = "Detail",
  onSubmit,
}: SidebarCardProps) {
  const { roomAvailable } = sidebarData;

  return (
    <Card className="!shadow-1 rounded-sm px-3 py-4">
      <SidebarcardHeader headerData={sidebarData} />

      {(roomAvailable || page === "Passengers" || page === "Confirm") && (
        <>
          <Separator
            direction="horizontal"
            className="my-4 bg-muted! hidden md:block"
          />

          <SidebarcardBody bodyData={sidebarData} />

          <Separator direction="horizontal" className="my-4 bg-muted!" />

          {/* - * - * - Discount Card - * - * - */}
          {page === "Confirm" && (
            <>
              <Discount />
              <Separator direction="horizontal" className="my-4 bg-muted!" />
            </>
          )}

          <SidebarcardFooter
            footerData={sidebarData}
            loading={loading}
            page={page}
            onSubmit={onSubmit}
          />
        </>
      )}
    </Card>
  );
}
